import { Controller } from "stimulus"

// #1978: het grote venster van een leadkaart.
// - Vergroten/verkleinen: het venster vult het scherm; de keuze blijft
//   bewaard in de browser (localStorage), ook voor de volgende kaart.
// - Een tabblad kiezen terwijl een veld nog wordt opgeslagen (sl-autosave):
//   eerst wacht het venster op het antwoord, daarna laadt het het gekozen
//   tabblad, zodat er niets verloren gaat.
// - Wijzigingen opslaan: het veld met de focus verlaten, zodat sl-autosave
//   het bewaart, en laten zien dat alles is opgeslagen.
// - Bestanden: slepen over de uploadzone kleurt hem; een gekozen of
//   neergezet bestand wordt meteen geüpload.
const SLEUTEL = "sl-venster-vol"

export default class extends Controller {
  static targets = ["vergroot", "inhoud", "status"]

  connect() {
    this.zetVol(this.bewaardVol())
  }

  vergroot(event) {
    event?.preventDefault()
    const vol = !this.element.classList.contains("is-vol")
    this.zetVol(vol)
    try { window.localStorage.setItem(SLEUTEL, vol ? "1" : "0") } catch (_fout) { /* privévenster */ }
  }

  zetVol(vol) {
    this.element.classList.toggle("is-vol", vol)
    if (this.hasVergrootTarget) this.vergrootTarget.setAttribute("aria-pressed", vol ? "true" : "false")
  }

  bewaardVol() {
    try { return window.localStorage.getItem(SLEUTEL) === "1" } catch (_fout) { return false }
  }

  wisselTab(event) {
    const link = event.target.closest("a[data-tab]")
    if (!link) return
    const bezig = this.element.querySelector("form[data-sl-bezig]")
    if (!bezig) return
    event.preventDefault()
    const href = link.href
    let klaar = false
    const verder = () => {
      if (klaar) return
      klaar = true
      // Na het antwoord van het opslaan tekent de stream het paneel opnieuw; daarna het gekozen tabblad laden
      setTimeout(() => {
        const frame = document.getElementById("sl_paneel")
        if (frame) frame.src = href
      }, 30)
    }
    bezig.addEventListener("turbo:submit-end", verder, { once: true })
    setTimeout(verder, 4000)
  }

  bewaarAlles(event) {
    event?.preventDefault()
    const actief = document.activeElement
    if (actief && this.element.contains(actief) && actief.form) actief.blur()
    const knop = event?.currentTarget
    setTimeout(() => {
      if (this.element.querySelector("form[data-sl-bezig]")) return
      if (this.hasStatusTarget && knop?.dataset.klaar) this.statusTarget.textContent = knop.dataset.klaar
    }, 200)
  }

  dropAan(event) {
    event.currentTarget.classList.add("is-erboven")
  }

  dropUit(event) {
    if (event.type === "dragleave" && event.currentTarget.contains(event.relatedTarget)) return
    event.currentTarget.classList.remove("is-erboven")
  }

  upload(event) {
    const veld = event.target
    if (!veld || veld.type !== "file" || !veld.files || veld.files.length === 0) return
    veld.closest(".sl-dropzone")?.classList.add("is-bezig")
    veld.form?.requestSubmit()
  }
}
